<template>
  <comHeader></comHeader>

  <div class="inner-banner">
    <section class="w3l-breadcrumb">
      <div class="container">
        <h4 class="inner-text-title font-weight-bold text-white mb-sm-3 mb-2">
          Electronic User Manual
        </h4>
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">Home</a></li>
          <li class="active">
            <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span>
            Electronic User Manual
          </li>
        </ul>
      </div>
    </section>
  </div>

 <section class="w3l-contact-11" style="width:100%;" id="illustration">
    <!-- <img class="img-fluid" src="@/assets/images/instru.jpg" alt="" /> -->
     <div class="img-container">
        <div class="img-item" v-for="bg in bgList" :key="bg">
            <img class="img-fluid"  :src="bg" alt="" />
        </div>
     </div>
    

 </section>

</template>

<script>
import comHeader from "@/components/comHeader.vue";
export default {
  name: "appIllustration",
  components: {
    comHeader,
  },
};
</script>
<script setup>
  import { onMounted, ref } from 'vue';

  const bgList = ref([])
  
  onMounted(() => {
    for(let i = 0; i < 10; i++) {
      for(let j = 0; j < 10; j++)
      bgList.value.push("instru_slices/instru_slice_" + (i+1) +"_"+ (j+1)+".jpeg")
    }
  })

</script>

<style scoped>
  .img-container{
      display: flex;
      flex-wrap: wrap;
      width:100%;
      height:100%;
      margin:0 auto;
    }

    .img-item{
      width:10%;
      display:flex;
      border:none;
    }

    .img-fluid { 
        width:100%;
        height: 100%;
        margin:0 auto;
        display:flex;
        flex-wrap: wrap;
    }
</style>